import type { DynamicFieldComponentProps } from '@myosh/odin-components';
import { OdinController } from '@myosh/odin-components';
import type { Control } from 'react-hook-form';
import type { SchedulerRule } from '../../../../@types/scheduler-record';
import NotificationPropsField from './notification-props-field';

interface HfNotificationPropsField extends DynamicFieldComponentProps<SchedulerRule> {
  control: Control;
}

export default function HfNotificationPropsField({
  control,
  name = 'notificationType',
  label,
  readOnly,
  onChange,
}: HfNotificationPropsField) {
  return (
    <OdinController
      name={name}
      control={control}
      onChange={onChange}
      render={({ field: { value, onChange }, fieldState: { error } }) => (
        <NotificationPropsField
          name={name}
          label={label}
          value={value}
          error={error?.message}
          readOnly={readOnly}
          onChange={onChange}
          control={control}
        />
      )}
    />
  );
}
